import { links } from 'utils/constants'

import { defaultRootStackScreens, prefixes } from './constants'

export const linking = () => {
  return {
    prefixes,
    config: {
      screens: {
        Root: {
          screens: defaultRootStackScreens,
        },
        [links.ONBOARDING_STACK]: {
          screens: {
            [links.ONBOARDING_USER_TYPE_PAGE]: '/onboarding',
            [links.ONBOARDING_EDIT_PROFILE_PAGE]: '/onboarding/profile',
          },
        },
        // Top level routes, not authenticated yet, so no tab bar
        [links.AUTH_WELCOME_PAGE]: '/welcome',
        [links.LOGIN_PAGE]: '/login',
        [links.SIGNUP_PAGE]: '/signup',
      },
    },
  }
}
